import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 3l-8 4.5l8 4.5","key":"svg-0"}],["path",{"d":"M8 12l8 4.5l-8 4.5","key":"svg-1"}]]

/**
 * IconBrandStocktwits
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtc3RvY2t0d2l0cyIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTYgM2wtOCA0LjVsOCA0LjUiIC8+CiAgPHBhdGggZD0iTTggMTJsOCA0LjVsLTggNC41IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/brand-stocktwits
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandStocktwits = createReactComponent('outline', 'brand-stocktwits', 'BrandStocktwits', __iconNode);

export default IconBrandStocktwits;